var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('style',{domProps:{"innerHTML":_vm._s(`.panel-footer.card-footer #sv-nav-next, .panel-footer.card-footer #sv-nav-complete, .panel-footer.card-footer #sv-nav-preview {display: none !important;}`)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }